const projectsdata = [
  {
    title: "Altinbas conference",
    image: "/altinbas.png",
    description:
      "an imaginary conference about altinbas university built using HTML5, CSS3, JavaScript",
    link: "https://alzubair98.github.io/Altinbas-conference/",
    githup: "https://github.com/Alzubair98/Altinbas-conference",
  },
  {
    title: "photos gallery",
    image: "/image_gallery.jpg",
    description: "project allow the user to search for any kind of images ",
    link: "https://master--golden-moonbeam-e14baa.netlify.app/",
    githup: "https://github.com/Alzubair98/images-gallery",
  },
  {
    title: "Space Hub",
    image: "/rockets.png",
    description:
      "Project to see the rockets and missions that are going to space , built using React, Redux and Api",
    link: "https://precious-tapioca-7e809f.netlify.app",
    githup: "https://github.com/Alzubair98/REACT-GROUP-PROJECT",
  },
  {
    title: "Book Store",
    image: "/books.jpg",
    description:
      "Project to save books, edit and delete them whenever you want, built using React and Api",
    link: "https://whimsical-phoenix-dd6566.netlify.app/",
    githup: "https://github.com/Alzubair98/books",
  },
  {
    title: "Math Magicians",
    image: "/math.jpg",
    description:
      "Project to do math with simple calculator and simple qoute, built using React",
    link: "https://genuine-mooncake-4a6c52.netlify.app/",
    githup: "https://github.com/Alzubair98/Math-magicians",
  },
  {
    title: "Leaderboard",
    image: "/score.webp",
    description:
      "A project to save your score in a game, built using HTML5, CSS3, JavaScript",
    link: "https://alzubair98.github.io/Leaderoard/dist/",
    githup: "https://github.com/Alzubair98/Leaderoard",
  },
  {
    title: "Recipe App",
    image: "/recipe.jpg",
    description:
      "A project to add foods and recipes , built using ruby on rails",
    link: "https://recipe-app-a778.onrender.com",
    githup: "https://github.com/Alzubair98/recipe_app",
  },
  // {
  //   title: "Budget App",
  //   image: "/budget.jpg",
  //   description:
  //     "A project allows write what you spend your money on , built using ruby on rails",
  //   link: "https://floating-shelf-06058.herokuapp.com/",
  // },
  // {
  //   title: "Blog App",
  //   image: "/blog_image.png",
  //   description:
  //     "A blog app project to share articles with other users , built using ruby on rails",
  //   link: "https://stormy-harbor-44250.herokuapp.com/",
  // },
  {
    title: "User portfolio",
    image: "/yousef.jpg",
    description:
      "an amazing portfolio for one of my clinets , bulit using React framework",
    link: "https://quiet-babka-389752.netlify.app/",
    githup: "https://github.com/Alzubair98/yousef-portfolio",
  },
  {
    title: "real estate app",
    image: "/real-estate.jpg",
    description: "a prject to show the flats that company sell to customers",
    link: "https://mellifluous-bienenstitch-8176b8.netlify.app/",
    githup: "https://github.com/Alzubair98/ozyapi",
  },
  {
    title: "GAU Conference",
    image: "/conference.jpg",
    description: "a projects for a conference in some university",
    link: "https://dtsmea.com/",
    githup: "#",
  },
  // {
  //   title: "Bikers",
  //   image: "/bikes.jfif",
  //   description:
  //     "an amazing project used to allow the users to rent bikes , bulit using Ruby on rails and React framework",
  //   link: "https://helpful-douhua-bfc6b0.netlify.app/",
  //   githup: "https://github.com/Alzubair98/group-project-front-end",
  // },
];

export default projectsdata;
